import Grid, { GridItem } from '@/components/layout/Grid';
import CampoTexto from '@/components/Formulario/CampoTexto';
import Botao from '@/components/Botao';
import { mdiTrashCan } from '@mdi/js';
import HBox from '@/components/layout/HBox';
import { EmpresaDominioDto } from '@tera/shared/src/dto/EmpresaDominioDto';

type ListaDominiosProps = {
  empresa_id: number;
  value: EmpresaDominioDto[];
  onChange: (value: EmpresaDominioDto[]) => void;
  error?: string;
};

export const ListaDominios = ({ empresa_id, value, onChange, error }: ListaDominiosProps) => {
  const handleAdd = () => {
    onChange([...value, { empresa_id, dominio: '' }]);
  };

  const handleChange = (index: number, val: EmpresaDominioDto) => {
    const newValue = [...value];
    newValue[index] = val;
    onChange(newValue);
  };

  const handleRemove = (index: number) => {
    const newValue = value.filter((_, i) => i !== index);
    onChange(newValue);
  };

  return (
    <div>
      <label style={{ fontWeight: 'bold', display: 'block', marginBottom: '0.5rem' }}>Domínios de Email/Site</label>
      {value.map((dominio, index) => (
        <HBox key={index}>
          <CampoTexto
            instanceId={`dominio-${index}`}
            value={dominio.dominio}
            onChange={v => handleChange(index, { ...dominio, dominio: v })}
            placeholder="dominio.com.br"
          />
          <Botao
            variant='outline-danger'
            onClick={() => handleRemove(index)}
            icon={mdiTrashCan}
          ></Botao>
        </HBox>
      ))}
      <Botao
        variant="outline-primary"
        onClick={handleAdd}
      >
        Adicionar Domínio
      </Botao>
      {error && <div style={{ color: 'red', marginTop: '0.5rem' }}>{error}</div>}
    </div>
  );
}


type FormEmpresaProps = {
  value: any;
  onChange: (value: any) => void;
  fieldErrors: Record<string, string>;
};

export const FormEmpresa = ({ value, onChange, fieldErrors }: FormEmpresaProps) => {
  const handleChange = (field: string, val: any) => {
    onChange({ ...value, [field]: val });
  };

  if (value == null)
    return null;

  return (
    <Grid>
      <GridItem sm={12} lg={6}>
        <CampoTexto
          instanceId='razao_social'
          value={value.razao_social || ''}
          onChange={v => handleChange('razao_social', v)}
          label="Razão Social"
          placeholder="Razão Social da empresa"
          required
          error={fieldErrors?.razao_social}
        />
      </GridItem>
      <GridItem sm={12} lg={6}>
        <CampoTexto
          instanceId='nome_fantasia'
          value={value.nome_fantasia || ''}
          onChange={v => handleChange('nome_fantasia', v)}
          label="Nome Fantasia"
          placeholder="Nome Fantasia (opcional)"
          error={fieldErrors?.nome_fantasia}
        />
      </GridItem>
      <GridItem sm={12}>
        <CampoTexto
          instanceId='cnpj'
          value={value.cnpj || ''}
          onChange={v => handleChange('cnpj', v)}
          label="CNPJ"
          placeholder="XX.XXX.XXX/XXXX-XX"
          error={fieldErrors?.cnpj}
        />
      </GridItem>
      <GridItem sm={12}>
        <ListaDominios
          empresa_id={value.id}
          value={value.dominios || []}
          onChange={v => handleChange('dominios', v)}
          error={fieldErrors?.dominios}
        />
      </GridItem>
    </Grid>
  );
};
